import {Component, Input, OnDestroy, OnInit, input} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import * as fromProfile from '../store/profile.reducers';
import {Chart} from 'angular-highcharts';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import {ActivatedRoute, Params} from '@angular/router';
import {ProfileService} from '../profile.service';
import * as DemoAction from '../../demo/store/demo.actions';
import * as ProfileAction from '../store/profile.actions';
import {ChartService} from '../chart.service';

import * as ProfileActions from './../store/profile.actions';


@Component({
    selector: 'app-profile-audit-pro',
    templateUrl: './profile-audit-pro.component.html',
    styleUrls: ['./profile-audit-pro.component.scss'],
    standalone: false
})
export class ProfileAuditProComponent implements OnInit, OnDestroy {

  profileState: Observable<fromProfile.State>;
  routeSubscription: Subscription;
  profileSubscription: Subscription;
  @Input() id: number;
  code: string;
  demoLoaded: boolean;
  initData: boolean;
  charts: Chart[];
  chartsFollowerEngage: Chart[];
  engagementStat: any[];
  engagementIndicator: any[];
  interactionAvg: any[];
  trialPercent: number;
  trialTimeout: any;
  demoBar: boolean;
  readonly type = input<'profile' | 'demo'>(undefined);

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
    private profileService: ProfileService
  ) {}

  getType(): 'profile' | 'demo' {
    const type = this.type();
    if (type === undefined) {
      return 'profile';
    }
    return type;
  }

  getAuditActions() {
    const type = this.type();
    if (type === undefined || type === 'profile') {
      return ProfileActions;
    } else if (type === 'demo') {
      return DemoAction;
    }
  }

  ngOnInit() {
    this.demoBar = true;
    this.trialPercent = 10;

    if (this.type() === 'profile') {
      this.store.dispatch(
        new ProfileAction.ClearCharts()
      );
      this.store.dispatch(
        new ProfileAction.SetAutoload(true)
      );
    }

    this.demoLoaded = false;
    this.engagementStat = this.profileService.getProfileEngagementStat();
    this.profileState = this.store.select(this.getType());
    this.routeSubscription = this.route.params.subscribe(
      (params: Params) => {
        if (params.id !== undefined) {
          this.id = params.id;
        }
        this.code = params.code;
        if (this.id !== undefined && this.type() === 'profile') {
          this.store.dispatch(
            new ProfileActions.GetProfileDetail({id: this.id, params: {code: this.code}})
          );
          this.store.dispatch(
            new ProfileActions.GetProfileProgress({id: this.id, params: {code: this.code}})
          );
          this.store.dispatch(
            new ProfileActions.GetAudit({id: this.id, params: {code: this.code}})
          );

          this.store.dispatch(
            new ProfileActions.GetFollowerEngage({
              id: +this.id,
              type: 1,
              params: {code: this.code}
            })
          );

        }
      }
    );
    this.profileSubscription = this.store.select(this.getType()).subscribe(
      (state: fromProfile.State) => {
        if (state.audit !== null && state.audit.status !== 0 && !this.initData && this.type() === 'profile') {
          this.initData = true;
          if (this.id !== undefined) {
            // tutaj
            this.store.dispatch(
              new ProfileActions.GetFollowerEngageIndicator({
                id: +this.id,
                type: 1,
                params: {code: this.code}
              })
            );
            this.store.dispatch(
              new ProfileActions.GetProfileScore({
                id: +this.id,
                params: {code: this.code}
              })
            );

          }
        }


        if (state.audit !== null && !this.demoLoaded) {
          this.demoLoaded = true;
          if (state.audit.status === 0) {
            this.store.dispatch(
              new DemoAction.GetDemo({id: 'f546bb3f-afcf-11ea-8dd2-d45d64400002', saveAsDemo: false})
            );
          }
        }

        if (
          state.profileProgress !== null &&
          state.profileProgress.media.percent < 100
        ) {
          if (this.trialTimeout !== undefined) {
            clearTimeout(this.trialTimeout);
          }
          this.trialTimeout = setTimeout(() => {
            if (state.profileProgress !== null && state.profileProgress.media.percent === 100) {
              this.trialPercent = 100;
            } else {
              this.trialPercent = Math.min(this.trialPercent + this.getRandomInt(1, 4), 94);
            }
          }, 6000);

        } else if (state.profileProgress !== null && state.profileProgress.media.percent === 100) {
          this.trialPercent = 100;
        }

        if (state.followerEngage !== null && state.chartReload === this.getAuditActions().SET_FOLLOWER_ENGAGE) {
          this.chartsFollowerEngage = [];
          this.chartsFollowerEngage.push(
            ChartService.getEngageByDayChart(state.followerEngage)
          );
          const engagementStat = this.profileService.getProfileEngagementStat();

          for (const i in engagementStat) {
            const e = engagementStat[i];
            if (e.range.from < state.followerEngage.follower_count && e.range.to > state.followerEngage.follower_count) {
              engagementStat[i]['profile'] = {
                engage: state.followerEngage.engage_count
              };
            }
          }
          this.engagementStat = engagementStat;
          this.interactionAvg = state.followerEngage;
        }

        if (state.followerEngageIndicator !== null && state.chartReload === this.getAuditActions().SET_FOLLOWER_ENGAGE_INDICATOR) {
          this.engagementIndicator = state.followerEngageIndicator;
        }

      }
    );
  }

  demoBarTrigger(): void {
    this.demoBar = !this.demoBar;
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }

  ngOnDestroy() {
    this.store.dispatch(
      new ProfileAction.SetAutoload(false)
    );
    this.routeSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
    if (this.trialTimeout !== undefined) {
      clearTimeout(this.trialTimeout);
    }
  }

}
